import React from 'react';
import _ from 'lodash';
import { PropTypes } from 'prop-types';
import styles from './CardType.css';

export const cardIdentifier = ccNum => {
  const numberArray = Array.from(ccNum);
  let card = 'Card';
  if (numberArray[0] === '4') {
    card = 'Visa';
    return card;
  } else if (
    numberArray[0] === '5' &&
    (numberArray[1] === '0' || '1' || '2' || '3' || '4' || '5')
  ) {
    card = 'MC';
    return card;
  } else if (
    (numberArray[0] === '6' &&
      (numberArray[1] === '0' &&
        numberArray[2] === '1' &&
        numberArray[3] === '1')) ||
    (numberArray[1] === '4' &&
      numberArray[2] === ('4' || '5' || '6' || '7' || '8' || '9')) ||
    numberArray[1] === '5'
  ) {
    card = 'DS';
    return card;
  } else if (numberArray[0] === '3' && (numberArray[1] === '4' || '7')) {
    card = 'AMEX';
    return card;
  }
  return card;
};

const CardType = ({ ccNum, paymentProfileId }) => {
  const thisCard = cardIdentifier(ccNum);
  return (
    <li key={paymentProfileId}>
      <p className={styles.cardContent}>
        {thisCard} ending in
        <span className={styles.last44ccNum}>
          {' '}
          {_.slice(ccNum, ccNum.length - 4)}
        </span>
      </p>
    </li>
  );
};

CardType.propTypes = {
  ccNum: PropTypes.string,
  paymentProfileId: PropTypes.string,
};

export default CardType;



// WEBPACK FOOTER //
// ./src/containers/Modals/CardType.jsx